// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentImage_wrapper__aZcJL","image":"ContentImage_image__52CbM"};